import { Button } from "antd";
import React from "react";
import { CiGrid2H } from "react-icons/ci";
import { CiGrid41 } from "react-icons/ci";

type Props = {
  view: boolean;
  setView: React.Dispatch<React.SetStateAction<boolean>>;
};

const ViewChanger = (props: Props) => {
  return (
    <div className="flex items-center gap-2">
      <Button
        type={props.view ? "primary" : "default"}
        onClick={() => props.setView(true)}
      >
        <CiGrid2H />
      </Button>
      <Button
        type={!props.view ? "primary" : "default"}
        onClick={() => props.setView(false)}
      >
        <CiGrid41 />
      </Button>
    </div>
  );
};

export default ViewChanger;
